import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
export function ImpressumPage() {
  return <div className="min-h-screen bg-white" data-id="element-1944">
      <Header data-id="element-1945" />
      <main className="w-full pt-32" data-id="element-1946">
        <div className="max-w-5xl mx-auto py-16 px-6 md:px-12" data-id="element-1947">
          <h1 className="text-3xl md:text-4xl font-light text-gray-700 mb-8" data-id="element-1948">
            Impressum
          </h1>
          <section className="mb-12" data-id="element-1949">
            <h2 className="text-2xl font-medium text-gray-700 mb-6" data-id="element-1950">
              Verantwortlich (Anbieter) für den Inhalt der Homepage:
            </h2>
            <div className="prose prose-lg max-w-none text-gray-600" data-id="element-1951">
              <p className="font-medium" data-id="element-1952">Dr. Dipl. Psych. Angelika Sturny</p>
              <p data-id="element-1953">Psychologische Praxis</p>
              <p data-id="element-1954">Feinerweg 18</p>
              <p data-id="element-1955">85540 Haar (b. München)</p>

              <p className="font-medium mt-6" data-id="element-1956">
                Inhaltlich verantwortlich nach § 18 Abs. 2 MStV:
              </p>
              <p data-id="element-1957">Dr. Angelika Sturny</p>

              <p className="font-medium mt-6" data-id="element-1958">Redaktionell verantwortlich:</p>
              <p data-id="element-1959">Dr. Angelika Sturny</p>

              <p className="font-medium mt-6" data-id="element-1960">Kontakt:</p>
              <p data-id="element-1961">
                E-Mail:{' '}
                <a href="mailto:praxis@angelikasturny.com" className="text-[#c2cde0] hover:text-[#a3b3d4] hover:font-semibold transition-colors" data-id="element-1962">
                  praxis@angelikasturny.com
                </a>
              </p>
              <p data-id="element-1963">
                Webseite:{' '}
                <a href="https://www.praxis-schifferer-sturny.com" target="_blank" rel="noopener noreferrer" className="text-[#c2cde0] hover:text-[#a3b3d4] hover:font-semibold transition-colors" data-id="element-1964">
                  www.praxis-schifferer-sturny.com
                </a>
              </p>

              <p className="font-medium mt-6" data-id="element-1965">Gesetzliche Berufsbezeichnung:</p>
              <p data-id="element-1966">
                Heilpraktikerin der Psychotherapie (Heilpraktiker beschränkt auf
                das Gebiet der Psychotherapie), verliehen in Deutschland
              </p>
              <p className="mt-2" data-id="element-1967">
                Aufsichtsführende Behörde: Landratsamt München, Mariahilfplatz
                17, 81541 München
              </p>

              <p className="font-medium mt-6" data-id="element-1968">
                Es gelten folgende berufsrechtliche Regelungen:
              </p>
              <p className="mt-2" data-id="element-1969">Heilpraktikergesetz (HeilprG)</p>
              <p data-id="element-1970">
                einsehbar unter:{' '}
                <a href="https://www.gesetze-im-internet.de/heilprg/BJNR002510939.html" target="_blank" rel="noopener noreferrer" className="text-[#c2cde0] hover:text-[#a3b3d4] hover:font-semibold transition-colors" data-id="element-1971">
                  https://www.gesetze-im-internet.de/heilprg/BJNR002510939.html
                </a>
              </p>
              <p className="mt-2" data-id="element-1972">
                Erste Durchführungsverordnung zum Heilpraktikergesetz
                (DVO-HeilprG)
              </p>
              <p data-id="element-1973">
                einsehbar unter:{' '}
                <a href="https://www.gesetze-im-internet.de/heilprgdv_1/BJNR002590939.html" target="_blank" rel="noopener noreferrer" className="text-[#c2cde0] hover:text-[#a3b3d4] hover:font-semibold transition-colors" data-id="element-1974">
                  https://www.gesetze-im-internet.de/heilprgdv_1/BJNR002590939.html
                </a>
              </p>

              <p className="font-medium mt-6" data-id="element-1975">Aufsichtsbehörde:</p>
              <p data-id="element-1976">
                Die Erlaubnis zur Ausübung der Heilkunde ohne Approbation,
                eingeschränkt auf das Gebiet der Psychotherapie, wurde Dr.
                Angelika Sturny erteilt am 18.11.2025 durch das Landratsamt
                München.
              </p>
            </div>
          </section>
          <hr className="my-12 border-gray-200" data-id="element-1977" />
          <section className="mb-12" data-id="element-1978">
            <div className="prose prose-lg max-w-none text-gray-600" data-id="element-1979">
              <p className="font-medium" data-id="element-1980">Eva Sophie Schifferer</p>
              <p data-id="element-1981">Psychologische Praxis Eva Sophie Schifferer</p>
              <p data-id="element-1982">Rohrbachstraße 35</p>
              <p data-id="element-1983">60389 Frankfurt</p>

              <p className="font-medium mt-6" data-id="element-1984">
                Inhaltlich verantwortlich nach § 18 Abs. 2 MStV:
              </p>
              <p data-id="element-1985">Eva Sophie Schifferer</p>

              <p className="font-medium mt-6" data-id="element-1986">Redaktionell verantwortlich:</p>
              <p data-id="element-1987">Eva Sophie Schifferer</p>

              <p className="font-medium mt-6" data-id="element-1988">Kontakt:</p>
              <p data-id="element-1989">
                Email:{' '}
                <a href="mailto:praxis@evaschifferer.com" className="text-[#c2cde0] hover:text-[#a3b3d4] hover:font-semibold transition-colors" data-id="element-1990">
                  praxis@evaschifferer.com
                </a>
              </p>
              <p data-id="element-1991">
                Webseite:{' '}
                <a href="https://www.praxis-schifferer-sturny.com" target="_blank" rel="noopener noreferrer" className="text-[#c2cde0] hover:text-[#a3b3d4] hover:font-semibold transition-colors" data-id="element-1992">
                  www.praxis-schifferer-sturny.com
                </a>
              </p>

              <p className="font-medium mt-6" data-id="element-1993">Gesetzliche Berufsbezeichnung:</p>
              <p data-id="element-1994">
                Heilpraktiker der Psychotherapie (Heilpraktiker beschränkt auf
                das Gebiet der Psychotherapie), verliehen in Deutschland.
              </p>
              <p className="mt-2" data-id="element-1995">
                Aufsichtsführende Behörde: Gesundheitsamt Stadt Frankfurt am
                Main, Breite Gasse 28, 60313 Frankfurt/Main
              </p>

              <p className="font-medium mt-6" data-id="element-1996">
                Es gelten folgende berufsrechtliche Regelungen:
              </p>
              <p className="mt-2" data-id="element-1997">Heilpraktikergesetz (HeilprG)</p>
              <p data-id="element-1998">
                einsehbar unter:{' '}
                <a href="https://www.gesetze-im-internet.de/heilprg/BJNR002510939.html" target="_blank" rel="noopener noreferrer" className="text-[#c2cde0] hover:text-[#a3b3d4] hover:font-semibold transition-colors" data-id="element-1999">
                  https://www.gesetze-im-internet.de/heilprg/BJNR002510939.html
                </a>
              </p>
              <p className="mt-2" data-id="element-2000">
                Erste Durchführungsverordnung zum Heilpraktikergesetz
                (DVO-HeilprG)
              </p>
              <p data-id="element-2001">
                einsehbar unter:{' '}
                <a href="https://www.gesetze-im-internet.de/heilprgdv_1/BJNR002590939.html" target="_blank" rel="noopener noreferrer" className="text-[#c2cde0] hover:text-[#a3b3d4] hover:font-semibold transition-colors" data-id="element-2002">
                  https://www.gesetze-im-internet.de/heilprgdv_1/BJNR002590939.html
                </a>
              </p>

              <p className="font-medium mt-6" data-id="element-2003">Aufsichtsbehörde:</p>
              <p data-id="element-2004">
                Die Erlaubnis zur Ausübung der Heilkunde ohne Approbation,
                eingeschränkt auf das Gebiet der Psychotherapie, wurde Eva
                Sophie Schifferer erteilt am 28.08.2025 durch das Ordnungsamt/
                Gesundheitsamt Frankfurt am Main.
              </p>

              <p className="font-medium mt-6" data-id="element-2005">Hinweise:</p>
              <p data-id="element-2006">
                Heilkundliche Tätigkeit ist von der Umsatzsteuer gemäß § 4 Nr.
                14 UStG befreit. Aus diesem Grund erheben wir für Psychotherapie
                nach dem Heilpraktikergesetz keine Umsatzsteuer und weisen diese
                folglich auch nicht aus.
              </p>
              <p className="mt-2" data-id="element-2007">Gerichtsstand: Frankfurt am Main</p>

              <p className="mt-6" data-id="element-2008">
                Eva Sophie Schifferer ist Mitglied im Berufsverband Deutscher
                Psychologinnen und Psychologen e. V. (BDP) sowie im Verband
                Freier Psychotherapeuten, Heilpraktiker für Psychotherapie und
                Psychologischer Berater e.V. (VFP).
              </p>
            </div>
          </section>
          <hr className="my-12 border-gray-200" data-id="element-2009" />
          <section data-id="element-2010">
            <h2 className="text-2xl font-medium text-gray-700 mb-6" data-id="element-2011">
              Allgemeine Hinweise
            </h2>
            <div className="space-y-8" data-id="element-2012">
              <div data-id="element-2013">
                <h3 className="text-xl font-medium text-gray-700 mb-4" data-id="element-2014">
                  Streitschlichtung
                </h3>
                <div className="prose prose-lg max-w-none text-gray-600" data-id="element-2015">
                  <p data-id="element-2016">
                    Die Europäische Kommission stellt eine Plattform zur
                    Online-Streitbeilegung (OS) bereit:{' '}
                    <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-[#c2cde0] hover:text-[#a3b3d4] hover:font-semibold transition-colors" data-id="element-2017">
                      https://ec.europa.eu/consumers/odr
                    </a>
                    . Unsere E-Mail-Adresse finden Sie oben im Impressum.
                  </p>
                  <p data-id="element-2018">
                    Wir sind nicht bereit oder verpflichtet, an
                    Streitbeilegungsverfahren vor einer
                    Verbraucherschlichtungsstelle teilzunehmen.
                  </p>
                </div>
              </div>
              <div data-id="element-2019">
                <h3 className="text-xl font-medium text-gray-700 mb-4" data-id="element-2020">
                  Haftungsausschluss
                </h3>
                <div className="prose prose-lg max-w-none text-gray-600" data-id="element-2021">
                  <p data-id="element-2022">
                    Die bereitgestellten Informationen auf dieser Website wurden
                    sorgfältig geprüft und werden regelmäßig aktualisiert.
                    Jedoch kann keine Haftung oder Garantie dafür übernommen
                    werden, dass alle Angaben zu jeder Zeit vollständig, richtig
                    und in letzter Aktualität dargestellt sind. Dies gilt
                    insbesondere für alle Links zu anderen Websites, auf die
                    direkt oder indirekt verwiesen wird. Alle Angaben können
                    ohne vorherige Ankündigung geändert, entfernt oder ergänzt
                    werden. Weder die Veröffentlichung noch ihr Inhalt dürfen
                    ohne die vorherige Genehmigung von Eva Schifferer, Frankfurt
                    am Main auf irgendeine Art verändert oder an Dritte verteilt
                    oder übermittelt werden.
                  </p>
                </div>
              </div>
              <div data-id="element-2023">
                <h3 className="text-xl font-medium text-gray-700 mb-4" data-id="element-2024">
                  Links
                </h3>
                <div className="prose prose-lg max-w-none text-gray-600" data-id="element-2025">
                  <p data-id="element-2026">
                    Diese Website enthält Verknüpfungen zu Websites Dritter
                    (externe Links). Diese Websites unterliegen der Haftung der
                    jeweiligen Betreiber. Der Anbieter hat bei der erstmaligen
                    Verknüpfung der externen Links die fremden Inhalte daraufhin
                    überprüft, ob etwaige Rechtsverstöße bestehen. Zu dem
                    Zeitpunkt waren keine Rechtsverstöße ersichtlich. Der
                    Anbieter hat keinerlei Einfluss auf die aktuelle und
                    zukünftige Gestaltung und auf die Inhalte der verknüpften
                    Seiten. Das Setzen von externen Links bedeutet nicht, dass
                    sich der Anbieter die hinter dem Verweis oder Link liegenden
                    Inhalte zu Eigen macht. Eine ständige Kontrolle der externen
                    Links ist für den Anbieter ohne konkrete Hinweise auf
                    Rechtsverstöße nicht zumutbar. Bei Kenntnis von
                    Rechtsverstößen werden jedoch derartige externe Links
                    unverzüglich gelöscht.
                  </p>
                </div>
              </div>
              <div data-id="element-2027">
                <h3 className="text-xl font-medium text-gray-700 mb-4" data-id="element-2028">
                  Datenschutz
                </h3>
                <div className="prose prose-lg max-w-none text-gray-600" data-id="element-2029">
                  <p data-id="element-2030">
                    Der Anbieter dieser Webseite verweist hiermit auf seine
                    aktuelle Datenschutzerklärung.
                  </p>
                </div>
              </div>
              <div data-id="element-2031">
                <h3 className="text-xl font-medium text-gray-700 mb-4" data-id="element-2032">
                  Urheberrecht
                </h3>
                <div className="prose prose-lg max-w-none text-gray-600" data-id="element-2033">
                  <p data-id="element-2034">
                    Sämtliche, diese Website ausmachende Kriterien, wie Layout,
                    Fotos, Texte, Logos, Links sind urheberrechtlich geschützt
                    und dürfen ohne Genehmigung der Verantwortlichen weder
                    kopiert noch sonst in irgendeiner Form verwendet werden.
                  </p>
                </div>
              </div>
              <div data-id="element-2035">
                <h3 className="text-xl font-medium text-gray-700 mb-4" data-id="element-2036">
                  Abmahnvereine und Serienabmahner
                </h3>
                <div className="prose prose-lg max-w-none text-gray-600" data-id="element-2037">
                  <p data-id="element-2038">
                    Das Besuchen dieser Website allein zu Zwecken der Abmahnung
                    – insbesondere durch Abmahnvereine oder ähnliche
                    Organisationen – wird ausdrücklich untersagt. Es liegt dem
                    Anbieter der Website fern, gegen gesetzliche Bestimmungen zu
                    verstoßen, noch durch fehlende Angaben einen
                    Wettbewerbsvorteil zu erlangen. Sollten Sie dennoch der
                    Meinung sein, dass der Anbieter mit seinem Onlineangebot
                    gegen geltendes Recht verstößt, so lassen Sie ihm dies in
                    Form eines (kostenfreien) freundlichen Hinweises wissen. Der
                    Anbieter wird den vermeintlichen Verstoß, sofern der Vorwurf
                    zutrifft, unverzüglich beseitigen. Sollte es auf diesen
                    Seiten zu Urheberrechtsverletzungen kommen – der Anbieter
                    tut alles, um Rechte Dritter zu achten – ist der Anbieter
                    unverzüglich über diesen Zustand zu informieren und von
                    jeder Haftung freizustellen.
                  </p>
                </div>
              </div>
              <div data-id="element-2039">
                <h3 className="text-xl font-medium text-gray-700 mb-4" data-id="element-2040">
                  Design und Bildnachweis:
                </h3>
                <div className="prose prose-lg max-w-none text-gray-600" data-id="element-2041">
                  <p data-id="element-2042">
                    Bildrechte:{' '}
                    <a href="https://www.fotograf-frankfurt.photo/de" target="_blank" rel="noopener noreferrer" className="text-[#c2cde0] hover:text-[#a3b3d4] hover:font-semibold transition-colors" data-id="element-2043">
                      Martin Leissl
                    </a>
                    ,{' '}
                    <a href="https://www.berndhartung.de/" target="_blank" rel="noopener noreferrer" className="text-[#c2cde0] hover:text-[#a3b3d4] hover:font-semibold transition-colors" data-id="element-2044">
                      Bernd Hartung
                    </a>
                  </p>
                  <p data-id="element-2045">
                    Logogestaltung:{' '}
                    <a href="https://www.b-99.de/" target="_blank" rel="noopener noreferrer" className="text-[#c2cde0] hover:text-[#a3b3d4] hover:font-semibold transition-colors" data-id="element-2046">
                      Sven Grot
                    </a>
                  </p>
                  <p data-id="element-2047">
                    Webdesign & Umsetzung:{' '}
                    <a href="https://simonbogner.de/" target="_blank" rel="noopener noreferrer" className="text-[#c2cde0] hover:text-[#a3b3d4] hover:font-semibold transition-colors" data-id="element-2048">
                      Simon Bogner
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
      <Footer data-id="element-2049" />
    </div>;
}